import { useState, MouseEvent } from "react";
import { useAppSelector } from "../../../context-store";
import copyClickboardUtils from "../../../utils/copy-clipboard";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import AllProfilesGridModel from "../../../models/company/allProfiles/response/AllProfilesGridModel";
import toasterUtils from "../../../utils/toaster-utils";
import { RoleEnum } from "../../../models/enums/RoleEnum";
import AddProfilesGridModel from "../../../models/company/addProfiles/response/AddProfilesGridModel";
import jobPostingService from "../../../services/company/job-posting-service";
import modalUtils from "../../../utils/modal-utils";
import addProfilesService from "../../../services/company/add-profiles-service";
import AddProfilesInterviewRoundsModel from "../../../models/company/addProfiles/response/AddProfilesInterviewRoundsModel";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import ScheduleInterviewRoundsComponent from "../add-profiles/ScheduleInterviewRoundsComponent";
import ScheduleInterviewRequest from "../../../models/candidate/request/ScheduleInterviewRequest";
import { InterviewTypeEnum } from "../../../models/enums/InterviewTypeEnum";
import ScheduleInterviewCompanyRequestModel from "../../../models/company/addProfiles/request/ScheduleInterviewCompanyRequestModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import ScheduleInterviewComponent from "../add-profiles/ScheduleInterviewComponent";
import IdNameModel from "../../../models/common/IdNameModel";
import AllProfilesGridChildComponent from "./AllProfilesGridChildComponent";

interface AllProfilesGridProps {
    candidateList: AllProfilesGridModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    nameFilterValue: string;
    timeSlotsList: IdNameModel[];
    onStatusUpdate: (row: AllProfilesGridModel) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
    onViewRatingAction: (interviewId: string) => void;
    onViewRecordingsAction: (zoomScheduleId: string) => void;
    onCandidateViewHistory: (candidateId: string) => void;
    onScheduleInterview: (row: ScheduleInterviewCompanyRequestModel) => void;
};

const AllProfilesGridComponent = (props: AllProfilesGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [roleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const [nameFilter, setNameFilter] = useState<string>(props.nameFilterValue);

    const copyClipboard = (message: string) => {
        copyClickboardUtils.copy(message);
    };

    const viewRating = (row: AllProfilesGridModel) => {
        props.onViewRatingAction(row.interviewId);
    };

    const viewRecordings = (row: AllProfilesGridModel) => {
        if (row.zoomScheduleId === null || row.zoomScheduleId === "") {
            toasterUtils.showWarning("No Recordings found for this Interview.");
        } else {
            props.onViewRecordingsAction(row.zoomScheduleId);
        }
    };

    const viewHistory = (candidateId: string) => {
        props.onCandidateViewHistory(candidateId);
    };

    const statusUpdate = (row: AllProfilesGridModel) => {
        props.onStatusUpdate(row);
    };

    const columnsCandidates = [
        { Key: "CandidateName", text: "Name", sort: true, searchable: true, display: true },
        //{ Key: "EmailId", text: "Email Id", sort: true, searchable: false, display: true },
        //{ Key: "MobileNumber", text: "Mobile No", sort: true, searchable: false, display: true },
        //{ Key: "PrimarySkillName", text: "Primary Skill", sort: true, searchable: false, display: true },
        { Key: "DesignationName", text: "Designation", sort: true, searchable: false, display: true },
        // { Key: "JobCode", text: "Jobcode", sort: false, searchable: false, display: true },
        { Key: "RecruiterName", text: "Recruiter", sort: false, searchable: false, display: true },
        //{ Key: "CompanyName", text: "Company", sort: false, searchable: false, display: Number(loggedInUser?.roleId) === Number(RoleEnum.Administrator) || Number(loggedInUser?.roleId) === Number(RoleEnum.PanelManagement) || Number(loggedInUser?.roleId) === Number(RoleEnum.IAIAccountManager) || Number(loggedInUser?.roleId) === Number(RoleEnum.IAIRecruiter) ? true : false },
        //{ Key: "CreatedDate", text: "Created Date", sort: false, searchable: false, display: true },
        { Key: "InterviewDate", text: "Interview Date", sort: false, searchable: false, display: true },
        // { Key: "InterviewTypeName", text: "Type", sort: false, searchable: false, display: true },
        { Key: "TotalRating", text: "Rating", sort: false, searchable: false, display: true },
        { Key: "StatusName", text: "Status", sort: true, searchable: false, display: true },
        //{ Key: "ZoomMeetingUrl", text: "Meeting URL", sort: false, searchable: false, display: true },
        //{ Key: "IAIRecruiterName", text: "IAI Recruiter", sort: false, searchable: false, display: Number(loggedInUser?.roleId) === Number(RoleEnum.Administrator) || Number(loggedInUser?.roleId) === Number(RoleEnum.PanelManagement) || Number(loggedInUser?.roleId) === Number(RoleEnum.IAIAccountManager) || Number(loggedInUser?.roleId) === Number(RoleEnum.IAIRecruiter) ? true : false },
        { Key: "Actions", text: "View Results", sort: false, searchable: false, display: true },
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        setNameFilter(value);
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    const openInterviewRoundsModel = (interviewRounds: AddProfilesInterviewRoundsModel[], objAddProfile: AddProfilesGridModel) => {
        const config: GeneralPoupConfig = {
            title: "Schedule Interview Rounds",
            content: (
                <ScheduleInterviewRoundsComponent
                    objAddProfile={objAddProfile}
                    interviewRoundsList={interviewRounds}
                    onCloseInterviewRounds={onCloseInterviewRoundsHandler}
                    onInterviewRoundSelect={onInterviewRoundSelectHandler}
                    onInterviewRatingDetails={onInterviewRatingDetailsHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseInterviewRoundsHandler = () => {
        modalUtils.closeModal();
    };

    const onInterviewRoundSelectHandler = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        openScheduleInterviewModel(objInterviewRound, objAddProfile);
    };

    const onInterviewRatingDetailsHandler = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        props.onViewRatingAction(objInterviewRound.interviewId);
    };

    const openScheduleInterviewModel = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        let scheduleInterview: ScheduleInterviewRequest = {
            candidateId: objAddProfile.candidateId,
            interviewDate: new Date(),
            interviewDateString: "",
            timeSlotId: 0,
            interviewTypeId: InterviewTypeEnum.Video,
            primarySkillId: 0,
            secondarySkills: [],
            termsAndConditions: true,
            requirementId: objAddProfile.requirementId,
            interviewId: objInterviewRound.interviewId
        };
        let objScheduleInterview: ScheduleInterviewCompanyRequestModel = {
            profileId: objAddProfile.profileId,
            userId: GuidEnum.Empty,
            requirementInterviewProcessId: objInterviewRound.requirementInterviewProcessId,
            requirementScheduleId: objInterviewRound.requirementScheduleId,
            interviewId: objInterviewRound.interviewId,
            interviewerId: null,
            scheduleInterviewRequestModel: scheduleInterview
        }
        const config: GeneralPoupConfig = {
            title: objInterviewRound.interviewId === null ? "Schedule Interview" : "Re Schedule Interview",
            content: (
                <ScheduleInterviewComponent
                    objScheduleInterview={objScheduleInterview}
                    timeSlotsList={props.timeSlotsList}
                    onCloseScheduleInterview={onCloseScheduleInterviewHandler}
                    onScheduleInterviewSave={onScheduleInterviewSaveHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseScheduleInterviewHandler = () => {
        modalUtils.closeModal();
    };

    const onScheduleInterviewSaveHandler = (objScheduleInterview: ScheduleInterviewCompanyRequestModel) => {
        props.onScheduleInterview(objScheduleInterview);
    };

    const scheduleInterview = (row: AllProfilesGridModel) => {
        modalUtils.showLoader();
        jobPostingService.getJobPostingById(row.requirementId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            if (res.data.isCalibrationCallCompleted && res.data.isClientApproved && res.data.panelsAvailable) {
                modalUtils.showLoader();
                addProfilesService.getRequirementInterviewRounds(row.requirementId, row.profileId).then((res) => {
                    modalUtils.closeModal();
                    if (!res.isSuccess || res.errorMessages.length > 0) {
                        toasterUtils.showError(res.errorMessages.toString());
                        return;
                    }
                    if (res.items.length > 0) {
                        let objAddProfile: AddProfilesGridModel = {
                            profileId: row.profileId,
                            requirementId: row.requirementId,
                            candidateId: row.candidateId,
                            candidateName: row.candidateName,
                            emailId: row.emailId,
                            mobileNumber: row.mobileNumber,
                            comments: '',
                            statusId: 0,
                            statusName: row.statusName,
                            vendorId: '',
                            vendorName: '',
                            addInterviewProcess: false,
                            createdDate: new Date(),
                            resumeTitle: '',
                            interviewDate: row.interviewDate,
                            totalRating: row.totalRating,
                            meetingUrl: row.zoomMeetingUrl,
                            interviewId: row.interviewId,
                            isRated: row.isRated,
                            createdDateString: ''
                        };
                        //if (row.addInterviewProcess) {
                        openInterviewRoundsModel(res.items, objAddProfile);
                        // } else {
                        //     openScheduleInterviewModel(res.items[0], row);
                        // }
                    }
                }).catch((error) => {
                    modalUtils.closeModal();
                    toasterUtils.showError(error);
                });
            } else {
                toasterUtils.showWarning("Cannot schedule Interview for this Requirement because either Calibration call not done or Client not approved or Panels not available.");
            }
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                {columnsCandidates.filter(column => column.display).map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={nameFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.candidateList.map((candidate: AllProfilesGridModel, index) => (
                                <AllProfilesGridChildComponent
                                    key={index}
                                    candidate={candidate}
                                    index={index}
                                    loggedInUser={loggedInUser}
                                    roleId={roleId}
                                    statusUpdate={statusUpdate}
                                    scheduleInterview={scheduleInterview}
                                    viewRating={viewRating}
                                    viewRecordings={viewRecordings}
                                    viewHistory={viewHistory}
                                    copyClipboard={copyClipboard}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default AllProfilesGridComponent;